import { DateTime } from 'luxon';
import { MasterDetailListEntry } from "@sdbn/common";

export class RFIDCard implements MasterDetailListEntry {

  id: number;
  nbr: string;
  techIdentifier: string;
  description: string;

  constructor(rfidcard: any) {
    this.id = rfidcard.id;
    this.nbr = rfidcard.nbr;
    this.techIdentifier = rfidcard.techIdentifier;
    this.description = rfidcard.description;
  }

  public get listTitle(): string {
    var title = '#' + this.nbr;
    if(this.description?.length > 0) {
      title += ' - ' + this.description.substring(0, 40);
    }
    return title;
  }

  public get listTitleDictionaryKey(): string {
    return null;
  }

  public get listSubTitle(): string {
    return null;
  }

  public get groupIdentifier(): String {
    return null;
  }

  public get childs(): Array<MasterDetailListEntry> {
    return null;
  }

}

export class RFIDCardDetails {
  id: number;
  nbr: string;
  techIdentifier: string;
  description: string;
  active: boolean;
  validFrom: Date;
  validUntil: Date;

  constructor(details: any) {
    this.id = details.id;
    this.nbr = details.nbr;
    this.techIdentifier = details.techIdentifier;
    this.description = details.description;
    this.active = details.active === true;

    if (details.validFrom != null) {
      const date = DateTime.fromISO(details.validFrom);
      if (date.isValid) {
        this.validFrom = new Date(date.year, date.month - 1, date.day);
      }
    }
    if (details.validUntil != null) {
      const date = DateTime.fromISO(details.validUntil);
      if (date.isValid) {
        this.validUntil = new Date(date.year, date.month - 1, date.day);
      }
    }
  }
}
